import React from 'react';
import { Box, Skeleton } from '@mui/material';

const ProgressOverviewLoading: React.FC = () => {
  return (
    <Box sx={{ width: '100%', py: 4, px: 2 }}>
      {/* Simple progress line skeleton */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height={8}
        sx={{
          borderRadius: 10,
          bgcolor: (theme) => theme.palette.grey[300],
          ...(theme) =>
            theme.applyStyles('dark', {
              bgcolor: theme.palette.grey[600],
            }),
        }}
      />
    </Box>
  );
};

export default ProgressOverviewLoading;
